<template>
  <div class="my-10 px-4 sm:px-10">
    <div class="bg-gray-100 block sm:flex sm:space-x-4">
      <div class="w-full  border border-gray-500 p-6">
        <v-text-field
          name="fullName"
          label="Buyer's Name"
          v-model="fullname"
        ></v-text-field>

        <v-text-field label="Project" v-model="project"></v-text-field>
        <v-text-field
          label="Project Details"
          v-model="project_details"
        ></v-text-field>

        <v-text-field label="Address" v-model="address"></v-text-field>
        <v-text-field
          label="Civil Status"
          v-model="civil_status"
        ></v-text-field>
        <v-text-field label="Citizenship" v-model="citizenship"></v-text-field>
        <v-text-field
          label="Occupation/Business"
          v-model="occupation"
        ></v-text-field>
        <v-text-field label="Birth Date" v-model="birthdate"></v-text-field>

        <v-text-field label="Email" v-model="email"></v-text-field>
        <v-text-field
          v-if="open_edits"
          label="Type New Email"
          v-model="new_email"
        ></v-text-field>
        <v-text-field label="Telephone" v-model="telephone"></v-text-field>
        <v-text-field label="Mobile" v-model="mobile"></v-text-field>
        <v-text-field
          v-if="open_edits"
          label="Type New Mobile"
          v-model="new_mobile"
        ></v-text-field>
      </div>

      <div class="w-full text-center">
        <button
          class="
            mt-4
            mb-1
            rounded-md
            md:mb-2
            w-full
            py-4
            text-white
            hover:bg-red-700
            outline-none
            focus:outline-none
            bg-color-btn
          "
          @click="propertiesSelection"
          color="primary"
        >
          My Properties
        </button>
        

        <button
          @click="bis"
          class="
            my-1
            w-full
            py-4
            rounded-md
            text-white
            hover:bg-red-700
            outline-none
            focus:outline-none
            bg-color-btn
          "
          color="primary"
          v-html="BIS"
        ></button>
      </div>
    </div>

    <v-btn class="mt-2 mb-1 w-full" color="gray" @click="cancel_edits"
      >Cancel</v-btn
    >
    <v-btn class="mt-1 mb-2 w-full" color="gray" @click="cancel_edits"
      >Submit</v-btn
    >
    <v-dialog
      v-model="messageDialog"
      persistent
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <div class="bg-white md:p-10">
        <div class="text-center font-bold text-2xl pb-10">NOTIFICATION</div>
        <div v-html="message" class="text-justify"></div>
        <div class="md:text-center pt-10">
          <button text class="mr-2" @click="acknowledge('no')">No</button>
          <button color="success" @click="acknowledge('yes')">Yes</button>
        </div>
      </div>
    </v-dialog>

    <v-dialog
      v-model="otpDialog"
      persistent
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <div class="bg-white p-10">
        <OTP />
      </div>
    </v-dialog>
    <v-snackbar top v-model="snackbar">
      {{ snackbarText }}
      <button text color="primary" @click="snackbar = false">
        Close
      </button>
    </v-snackbar>
  </div>
</template>
<script>
import OTP from "@/screens/authScreen/components/Otp_UpdateInformation.vue";
import EventBus from "@/EventBus";
import SecureStorage from "../../utils/secureStorage";
// import InputFields from "./components/InputFields.vue";
export default {
  data() {
    return {
      telephone: "",
      address: "",
      civil_status: "",
      citizenship: "",
      occupation: "",
      birthdate: "",
      snackbar: false,
      snackbarText: "",
      new_email: "",
      new_mobile: "",
      open_edits: false,
      BIS: `BUYER'S INFORMATION SHEET.<br> Update your other personal and contact information here.`,
      updateSuccessDialog: false,
      updateSuccessMsg: "",
      otpTrue: false,
      otpDialog: false,
      list: [],
      fullname: SecureStorage.getItem("auth").buyerName,
      project: "",
      project_details: "",
      email: SecureStorage.getItem("auth").email,
      mobile: SecureStorage.getItem("auth").mobile,
      messageDialog: false,
      message:
        "You are requesting to change your registered E-mail Address and/or your registered Mobile Number for your account in our system. <br> <br> By submitting this request, you agree that once your registered contact information has been successfully updated, you will use the new contact information to access the Moldex Customer Service Website, and all official notices from Moldex will be sent to the new contact information you have provided.",
    };
  },
  components: {
    OTP,
  },
  mounted() {
    EventBus.$on("snackbarMyAccount", (msg) => {
      this.snackbar = true;
      this.snackbarText = msg;
    });
    EventBus.$on("otpDialog_close", () => {
      this.otpDialog = false;
      this.open_edits = false;
      this.new_email = "";
      this.new_mobile = "";
    });
  },
  beforeDestroy() {
    EventBus.$off("snackbarMyAccount");
    EventBus.$off("otpDialog_close");
  },
  methods: {
    cancel_edits() {
      this.new_mobile = "";
      this.new_email = "";
      this.open_edits = false;
      this.$router.push({
        name: "Home Dashboard",
        query: {
          cc: this.$route.query.cc,
          cn: this.$route.query.cn,
        },
      });
    },
    propertiesSelection() {
      this.$router.push({
        name: "Property Selection",
        query: {
          cc: this.$route.query.cc,
        },
      });
    },
    bis() {
      alert("Under construction");
      // this.$router.push({
      //   name: "Buyer's Information Sheet",
      // });
    },

    otpEnter() {
      // otpTrue
      this.otpTrue = true;
      if (this.otpTrue) {
        this.updateSuccessDialog = true;
        this.updateSuccessMsg =
          "Your registered contact information has been successfully updated in our system.You may start using the new e-mail address to access the Customer Service Website.";
      }
    },
    acknowledge(x) {
      if (x == "yes") {
        this.messageDialog = false;
        this.otpDialog = true;
      } else {
        this.messageDialog = false;
        this.cancel_edits();
      }
    },
  },
};
</script>

<style>
.bg-color-btn {
  background-color: #732a2a;
}
</style>
